import type * as Types from 'app/types/graphql';

import {
  UsageFeeTierEdgeSelectFragmentDoc,
  UsageFeeTierSelectFragmentDoc,
} from '../fragments/usageFeeTier.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type UsageFeeTiersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Array<Types.UsageFeeTierOrder>>;
  where?: Types.InputMaybe<Types.UsageFeeTierWhereInput>;
}>;

export type UsageFeeTiersQueryResponse = {
  usageFeeTiers?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<{
        node?: Types.Maybe<
          Pick<
            Types.UsageFeeTier,
            | 'id'
            | 'max'
            | 'min'
            | 'planID'
            | 'rangeSize'
            | 'amount'
            | 'currency'
            | 'source'
            | 'startAt'
            | 'endAt'
          >
        >;
      }>
    >;
  }>;
};

export const UsageFeeTiersDocument = `
    query UsageFeeTiers($first: Int, $last: Int, $orderBy: [UsageFeeTierOrder!], $where: UsageFeeTierWhereInput) {
  usageFeeTiers(first: $first, last: $last, orderBy: $orderBy, where: $where) {
    ...UsageFeeTierEdgeSelect
  }
}
    ${UsageFeeTierEdgeSelectFragmentDoc}
${UsageFeeTierSelectFragmentDoc}`;

export const useUsageFeeTiersQuery = <TData = UsageFeeTiersQueryResponse, TError = unknown>(
  variables?: UsageFeeTiersQueryVariables,
  options?: UseQueryOptions<UsageFeeTiersQueryResponse, TError, TData>,
) => {
  return useQuery<UsageFeeTiersQueryResponse, TError, TData>(
    variables === undefined ? ['UsageFeeTiers'] : ['UsageFeeTiers', variables],
    appFetcher<UsageFeeTiersQueryResponse, UsageFeeTiersQueryVariables>(
      UsageFeeTiersDocument,
      variables,
    ),
    options,
  );
};

useUsageFeeTiersQuery.getKey = (variables?: UsageFeeTiersQueryVariables) =>
  variables === undefined ? ['UsageFeeTiers'] : ['UsageFeeTiers', variables];
